"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountSuccess = exports.accountRestore = exports.accountReset = exports.accountHardDelete = exports.accountError = exports.accountEnable = exports.accountDisable = exports.accountDelete = exports.accountClean = void 0;
var _account = require("./account.constant");
// @flow

// common success
var accountSuccess = function accountSuccess(actionType, data) {
  return {
    type: _account.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.accountSuccess = accountSuccess;
var accountError = function accountError(actionType, error) {
  return {
    type: _account.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * account disable
 * @param payload
 * @returns api response
 * @description this function used to disable account of given id.
 */
exports.accountError = accountError;
var accountDisable = function accountDisable(data) {
  return {
    type: _account.actionTypes.DISABLE,
    payload: data
  };
};

/**
 * account enable
 * @param payload
 * @returns api response
 * @description this function used to enable account of given id.
 */
exports.accountDisable = accountDisable;
var accountEnable = function accountEnable(data) {
  return {
    type: _account.actionTypes.ENABLE,
    payload: data
  };
};

/**
 * account restore
 * @param payload
 * @returns api response
 * @description this function used to restore account of given id.
 */
exports.accountEnable = accountEnable;
var accountRestore = function accountRestore(data) {
  return {
    type: _account.actionTypes.RESTORE,
    payload: data
  };
};

/**
 * account clean
 * @param payload
 * @returns api response
 * @description this function used to clean account of given id.
 */
exports.accountRestore = accountRestore;
var accountClean = function accountClean(data) {
  return {
    type: _account.actionTypes.CLEAN,
    payload: data
  };
};

/**
 * account deletes
 * @param payload
 * @returns api response
 * @description this function used to deletes account of given id.
 */
exports.accountClean = accountClean;
var accountDelete = function accountDelete(data) {
  return {
    type: _account.actionTypes.DELETE,
    payload: data
  };
};

/**
 * account hard deletes
 * @param payload
 * @returns api response
 * @description this function used to deletes account of data.
 */
exports.accountDelete = accountDelete;
var accountHardDelete = function accountHardDelete(data) {
  return {
    type: _account.actionTypes.HARD_DELETE,
    payload: data
  };
};

/**
 * account reset
 * @param payload
 * @returns api response
 * @description this function used to reset account of data.
 */
exports.accountHardDelete = accountHardDelete;
var accountReset = function accountReset() {
  return {
    type: _account.actionTypes.RESET
  };
};
exports.accountReset = accountReset;